import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { isTruthy } from '@stimcar/libs-kernel';
import * as m from '../paraglide/messages.js';
import { App } from './App.js';
import './app.css';

const root = document.getElementById('root');
if (!isTruthy(root)) {
  throw new Error(m.missingRootElement());
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
